import React, { Component } from 'react';
import CanvasClockComponent from './components/canvas_clock'
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <CanvasClockComponent />
        </header>
      </div>
    );
  }
}

export default App;
